import { render, staticRenderFns } from "./updAddress.vue?vue&type=template&id=c1588d5c&scoped=true"
import script from "./updAddress.vue?vue&type=script&lang=js"
export * from "./updAddress.vue?vue&type=script&lang=js"
import style0 from "./updAddress.vue?vue&type=style&index=0&id=c1588d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1588d5c",
  null
  
)

export default component.exports